import { render, staticRenderFns } from "./AccountInfo.vue?vue&type=template&id=5f87928f&scoped=true&"
import script from "./AccountInfo.vue?vue&type=script&lang=js&"
export * from "./AccountInfo.vue?vue&type=script&lang=js&"
import style0 from "./AccountInfo.vue?vue&type=style&index=0&id=5f87928f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f87928f",
  null
  
)

export default component.exports